import actions from '../../redux/actions';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {useEffect, useRef, useState} from 'react';
import {deleteExtraSpaces} from '../../utils/util';
import React from 'react';
import Table from '../../common/components/ItemTable/v2/Table';
import './AmountList.scss';
import CustomAlert from '../../common/components/Alert/CustomAlert';
import Loader from '../../common/components/Loader/Loader';
import ExcelDownloadButton from '../../common/components/ExcelDownloadButton/ExcelDownloadButton';
import Ebutton from '../../common/components/Ebutton/Ebutton';
import Button from '../../common/components/Button/Button';


const _AmountList = (props) => {
    const {
        name,
        title,
        getAmount,
        amountList,
        getAmountListState,
        getAllAmountsToDownload,
        setListConfig,
        role,
        amountListToDownload,
        branches,
        getBranchesState,
        getBranches,
        cleanBranches,
        cleanAmountListState,
    } = props;

    const [listdata, setListData] = useState([]);
    // super admin vea prestador tambien

    const [items, setItems] = useState([]);
    const [pageQuantity, setPageQuantity] = useState(Math.ceil(amountList?.totalCount));
    const [branchesOptions, setBranchesOptions] = useState([]);
    const [provider, setProvider] = useState(undefined);
    const [currentPage, setCurrentPage] = useState(0);

    const isInitialMount = useRef(true);

    const headersDict = {
        'PROVIDER_ADMIN': [['Código', 'Descripción', 'Valor', 'Prestador', 'Id prestación']],
        'ADMIN': [['Código', 'Descripción', 'Valor', 'Prestador', 'Id prestación', 'Id prestador']],
    };


    useEffect(() => {
        switch (role) {
            case 'PROVIDER_ADMIN':
                setListData([
                    {title: 'Descripción', id: 'description', att: 'description', flex: 2},
                    {title: 'Código', id: 'code', att: 'code', flex: 1},
                    {title: 'Valor fijado', id: 'value', att: 'value', flex: 1, renderCell: (params) => <p className={'body-3 c-text-base'}>${params.row.value}</p>}]);
                getAllAmountsToDownload();
                getAmount();
                break;
            case 'ADMIN':
                setListData([
                    {title: 'ID', att: 'id', width: '10%'},
                    {title: 'DESCRIPCIÓN', att: 'description', width: '30%'},
                    {title: 'CODIGO', att: 'code', width: '20%'},
                    {title: 'VALOR FIJADO', att: 'value', width: '20%'}]);
                getBranches();
                break;
        }
    }, []);

    useEffect(() => {
        setItems(amountList.amounts);
        setPageQuantity(Math.ceil(amountList?.totalCount / amountList?.itemsPerPage));
    }, [amountList, getAmountListState.success]);

    useEffect(() => {
        if (!isInitialMount.current) {
            setListConfig({
                list: 'amountListConfig',
                config: {page: currentPage},
            });
            getAmount();
        }
        isInitialMount.current = false;
        // eslint-disable-next-line
    }, [currentPage]);


    useEffect(() => {
        if (!provider) {
            cleanBranches();
        } else {
            setListConfig({
                list: 'amountListConfig',
                config: {page: currentPage, providerName: provider},
            });
            getAmount();
            getAllAmountsToDownload();
        }
    }, [provider]);


    useEffect(() => {
        if (currentPage > pageQuantity) setCurrentPage(pageQuantity);
        // eslint-disable-next-line
    }, [amountList]);


    useEffect(() => {
            setBranchesOptions(branches?.map((branch) => {
                return {value: branch.fullName, label: deleteExtraSpaces(branch.fullName)};
            }));
        }
        , [branches, getBranchesState.success]);


    return (
        <div className={'page-content-container'}>
            <p className={'h3 v2-c-text-title'}>Grilla de valores</p>
            <div className={'page-table-container'}>
                <div className={'amount-list-download-button-container'}>
                    {amountListToDownload.length > 0 ?
                        <ExcelDownloadButton data={amountListToDownload} headers={headersDict[role]}
                                             fileName={`GRILLA_DE_VALORES:${role === 'ADMIN' ? 'TODAS' : name}-
                                                 FECHA DE EMISION:${new Date().toLocaleDateString()}`}/> :
                        <Button disabled={true} size={'small'}><Loader width={'14px'} height={'14px'}/></Button>
                    }
                </div>
                <div style={{height: '600px'}}>
                    {getAmountListState.success && items?
                        <Table attributes={listdata} rows={items} currentPage={currentPage}
                               rowCount={amountList.totalCount} onPageChange={(value) => setCurrentPage(value)}/> :
                        getAmountListState.loading ?
                        <Loader/> : getAmountListState.error &&
                        <CustomAlert text={'Grilla de valores' || String(getAmountListState.error)}
                     severity='error'/>
                }
                </div>
            </div>

        </div>

    );
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    title: state.home.title,
    amountList: state.home.amountList,
    getAmountListState: state.home.getAmountListState,
    role: state.login.userInfo.role.name,
    amountListToDownload: state.home.amountListToDownload,
    branches: state.home.branches,
    getBranchesState: state.home.getBranchesState,
});


const mapDispatchToProps = (dispatch) => ({
    getAmount: () => dispatch(actions.home.getAmountListRequest()),
    getAllAmountsToDownload: () => dispatch(actions.home.getAllAmountsToDownloadRequest()),
    setListConfig: (body) => dispatch(actions.home.setListConfig(body)),
    getBranches: () => dispatch(actions.home.getBranchesRequest()),
    cleanBranches: () => dispatch(actions.home.cleanBranches()),
    cleanAmountListState: () => dispatch(actions.home.cleanAmountListState()),
});

_AmountList.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    getAmount: PropTypes.func,
    amountList: PropTypes.object,
    getAmountListState: PropTypes.object,
    amountListToDownload: PropTypes.array,
};
export default connect(mapStateToProps, mapDispatchToProps)(_AmountList);
